// extracted by mini-css-extract-plugin
export default {"confirmBttn":"_physical-exam-outcome-comment-modal_confirmBttn__uFEQx","deleteBttn":"_physical-exam-outcome-comment-modal_deleteBttn__EXsiy"};